import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NeedAuthorize } from '../../classes/needAuthorize';
import { UserService } from '../../services/user/user.service';
import { InventoryService } from '../../services/inventory/inventory.service';
import { HttpClient } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent extends NeedAuthorize implements OnInit {
  inventoryProducts: any[] = [];
  filteredProducts: any[] = [];
  loading = false;
  error = '';
  searchTerm = '';
  newProduct = { sku: '', name: '', image: '' };
  imageUpload = { loading: false, error: '' };
  inputModel = { productId: '', number: 1, note: '' };
  inputModalError = '';
  inputModalLoading = false;
  outputModel = { productId: '', number: 1, note: '' };
  outputModalError = '';
  outputModalLoading = false;
  historyProduct: any = null;
  historyRecords: any[] = [];
  historyLoading = false;
  historyError = '';
  editProduct: any = { id: '', sku: '', name: '', image: '' };
  productToDelete: any = null;
  
  // Image preview properties
  imagePreviewVisible = false;
  imagePreviewSrc = '';
  imagePreviewX = 0;
  imagePreviewY = 0;

  openCreateProductModal() {
    const unixTime = Math.floor(Date.now() / 1000);
    this.newProduct = { sku: `CG_${unixTime}`, name: '', image: '' };
    this.imageUpload = { loading: false, error: '' };
    $('#createProductModal').modal('show');
  }

  closeCreateProductModal() {
    $('#createProductModal').modal('hide');
  }

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    this.imageUpload = { loading: true, error: '' };
    const formData = new FormData();
    formData.append('file', file);
    this.http.post<any>('/api/inventory/UploadImage', formData).subscribe({
      next: (res) => {
        // The API returns a string (link or comma-separated links)
        if (res && typeof res === 'string' && res.length > 0) {
          this.newProduct.image = res.split(',')[0];
          this.imageUpload.loading = false;
        } else {
          this.imageUpload = { loading: false, error: 'Không lấy được link ảnh' };
        }
      },
      error: () => {
        this.imageUpload = { loading: false, error: 'Lỗi tải ảnh lên Dropbox' };
      }
    });
  }

  submitCreateProduct() {
    if (!this.newProduct.sku || !this.newProduct.name || !this.newProduct.image) return;
    const payload = {
      SKU: this.newProduct.sku,
      Name: this.newProduct.name,
      Image: this.newProduct.image
    };
    this.inventoryService.createProduct(payload).subscribe({
      next: () => {
        this.loadProducts();
        this.closeCreateProductModal();
      },
      error: () => {
        alert('Lỗi tạo sản phẩm');
      }
    });
  }

  openInputModal() {
    this.inputModel = { productId: '', number: 1, note: '' };
    this.inputModalError = '';
    this.inputModalLoading = false;
    ($('#inputModal') as any).modal('show');
  }

  closeInputModal() {
    ($('#inputModal') as any).modal('hide');
  }

  submitInputModal() {
    if (!this.inputModel.productId || !this.inputModel.number) {
      this.inputModalError = 'Vui lòng nhập đầy đủ thông tin.';
      return;
    }
    this.inputModalLoading = true;
    this.inputModalError = '';
    this.inventoryService.inputProduct({
      ProductId: this.inputModel.productId,
      Number: this.inputModel.number,
      Note: this.inputModel.note
    }).subscribe({
      next: () => {
        this.inputModalLoading = false;
        this.closeInputModal();
        this.loadProducts();
      },
      error: (err) => {
        this.inputModalLoading = false;
        this.inputModalError = err?.error || 'Lỗi nhập kho';
      }
    });
  }

  openOutputModal() {
    this.outputModel = { productId: '', number: 1, note: '' };
    this.outputModalError = '';
    this.outputModalLoading = false;
    ($('#outputModal') as any).modal('show');
  }

  closeOutputModal() {
    ($('#outputModal') as any).modal('hide');
  }

  submitOutputModal() {
    if (!this.outputModel.productId || !this.outputModel.number) {
      this.outputModalError = 'Vui lòng nhập đầy đủ thông tin.';
      return;
    }
    this.outputModalLoading = true;
    this.outputModalError = '';
    this.inventoryService.outputProduct({
      ProductId: this.outputModel.productId,
      Number: this.outputModel.number,
      Note: this.outputModel.note
    }).subscribe({
      next: () => {
        this.outputModalLoading = false;
        this.closeOutputModal();
        this.loadProducts();
      },
      error: (err) => {
        this.outputModalLoading = false;
        this.outputModalError = err?.error || 'Lỗi xuất kho';
      }
    });
  }

  openHistoryModal(product: any) {
    this.historyProduct = product;
    this.historyRecords = [];
    this.historyLoading = true;
    this.historyError = '';
    ($('#historyModal') as any).modal('show');
    this.inventoryService.getHistory(product.id).subscribe({
      next: (records) => {
        this.historyRecords = records;
        this.historyLoading = false;
      },
      error: (err) => {
        this.historyError = err?.error || 'Lỗi tải lịch sử';
        this.historyLoading = false;
      }
    });
  }

  closeHistoryModal() {
    this.historyProduct = null;
    this.historyRecords = [];
    this.historyLoading = false;
    this.historyError = '';
    ($('#historyModal') as any).modal('hide');
  }

  openEditProductModal(item: any) {
    this.editProduct = { id: item.id, sku: item.sku, name: item.name, image: item.image };
    ($('#editProductModal') as any).modal('show');
  }

  closeEditProductModal() {
    this.editProduct = { id: '', sku: '', name: '', image: '' };
    ($('#editProductModal') as any).modal('hide');
  }

  submitEditProduct() {
    this.inventoryService.editProduct(this.editProduct.id, {
      SKU: this.editProduct.sku,
      Name: this.editProduct.name,
      Image: this.editProduct.image
    }).subscribe({
      next: () => {
        this.loadProducts();
        this.closeEditProductModal();
      },
      error: () => {
        alert('Lỗi cập nhật sản phẩm');
      }
    });
  }

  confirmDeleteProduct(item: any) {
    this.productToDelete = item;
    ($('#deleteProductModal') as any).modal('show');
  }

  closeDeleteProductModal() {
    this.productToDelete = null;
    ($('#deleteProductModal') as any).modal('hide');
  }

  deleteProduct() {
    if (!this.productToDelete) return;
    this.inventoryService.deleteProduct(this.productToDelete.id).subscribe({
      next: () => {
        this.loadProducts();
        this.closeDeleteProductModal();
      },
      error: () => {
        alert('Lỗi xóa sản phẩm');
      }
    });
  }

  constructor(
    protected router: Router,
    protected userService: UserService,
    protected titleService: Title,
    private inventoryService: InventoryService,
    private http: HttpClient
  ) {
    super(router, userService, titleService);
  }

  ngOnInit(): void {
    this.loadProducts();
  }

  loadProducts() {
    this.loading = true;
    this.error = '';
    this.inventoryService.getProducts().subscribe({
      next: (data) => {
        // Sort products by name
        this.inventoryProducts = data.sort((a, b) => a.name.localeCompare(b.name));
        this.filterProducts(); // Initialize filtered products
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Lỗi tải danh sách sản phẩm';
        this.loading = false;
      }
    });
  }

  // Add groupBy function for ng-select
  groupByFirstWord = (item: any) => (item.name?.split(' ')[0] || '');

  // Image preview methods
  showImagePreview(event: MouseEvent, imageSrc: string) {
    if (!imageSrc) return;
    
    this.imagePreviewSrc = imageSrc;
    this.imagePreviewVisible = true;
    this.updateImagePreview(event);
  }

  hideImagePreview() {
    this.imagePreviewVisible = false;
    this.imagePreviewSrc = '';
  }

  updateImagePreview(event: MouseEvent) {
    if (!this.imagePreviewVisible) return;
    
    // Add offset to position the tooltip above the cursor
    this.imagePreviewX = event.clientX;
    this.imagePreviewY = event.clientY - 20;
  }

  // Search functionality
  onSearchChange() {
    this.filterProducts();
  }

  clearSearch() {
    this.searchTerm = '';
    this.filterProducts();
  }

  filterProducts() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      this.filteredProducts = [...this.inventoryProducts];
    } else {
      const searchLower = this.searchTerm.toLowerCase().trim();
      this.filteredProducts = this.inventoryProducts.filter(product => 
        product.name.toLowerCase().includes(searchLower) ||
        product.sku.toLowerCase().includes(searchLower)
      );
    }
  }
} 
